export default __webpack_public_path__ + "static/media/0eb63b2b3937c74a.76c2de2ef862021abd20d1f0cd79963d.svg";